import classNames from 'classnames';
import React, { Component } from 'react';
import { FormFeedback } from 'reactstrap';

class ValidatingPasswordInput extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const errorFeedback = nextProps.validationFn(nextProps.value);
    return {
      errorFeedback,
      isBlurred: prevState.isBlurred,
      isValid: !errorFeedback,
      value: nextProps.value,
      wasValid: prevState.wasValid
        ? true
        : !errorFeedback,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      errorFeedback: null,
      isBlurred: false,
      isValid: !this.props.required,
      value: this.props.initialValue || '',
      wasValid: false,
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  // ----------------------
  // Computed
  // ----------------------

  get applyInvalidCssClass() {
    return (
      (this.state.isBlurred && !this.state.isValid) ||
      (this.state.wasValid && !this.state.isValid)
    );
  }

  get classNames() {
    return classNames('form-control', {
      'is-invalid': this.applyInvalidCssClass,
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  handleBlur() {
    if (!this.state.isBlurred) {
      this.setState({ isBlurred: true });
    }
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.props.onChange({
      isValid: !this.props.validationFn(value),
      name,
      value,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="form-group">
        <label htmlFor={this.props.name}>
          {this.props.label}:
          {this.props.required &&
            <i className="fa fa-asterisk" />
          }
        </label>
        <input
          className={this.classNames}
          id={this.props.name}
          name={this.props.name}
          onBlur={this.handleBlur}
          onChange={this.handleInput}
          type="password"
          value={this.state.value}
        />
        <FormFeedback>{this.state.errorFeedback}</FormFeedback>
      </div>
    );
  }
}

export default ValidatingPasswordInput;
